import { combineReducers } from '@reduxjs/toolkit';

import softwareProducts from 'software_products/redux/slice';
import inlineFormalQuote from 'formal_quote/inline_formal_quote/redux/slice';

const rootReducer = combineReducers({
  softwareProducts,
  inlineFormalQuote,
});

export default rootReducer;
